import { Box } from "@mui/material";
import { BlurredBackground } from "components/primitives/BlurredBackground";
import { DrawerSubHeaderText } from "components/primitives/DrawerSubHeaderText";
import { DrawerToggleIndicator } from "components/primitives/DrawerToggleIndicator";
import { HeaderText } from "components/primitives/HeaderText";
import { SwipeableArea } from "components/primitives/SwipeableArea";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { DrawerWrapper } from "../components/orderStepDrawerStyles";
import type { BaseOrderStepProps } from "../OrderStep2";
import { NumberedSteps } from "./NumberedSteps";
import { PhoneCheckIllustration } from "./PhoneCheckIllustration";

/**
 * Non-RFID prototype, door closed: the handoff to the phone. Replaces the stock check and the summary;
 * the 20 s "back to home" countdown lives in DrawerActionBar so it survives the FINISHED frame.
 */
export const NonRfidFinishStep = ({ open, toggleDrawer }: BaseOrderStepProps) => {
	const { t } = useTranslation();

	// The handoff must be seen: open the drawer even if the customer swiped it down while taking meals.
	useEffect(() => {
		toggleDrawer(true);
	}, [toggleDrawer]);

	return (
		<>
			<SwipeableArea orderstep={5} open={open}>
				{!open && <BlurredBackground orderStep={5} open={open} />}
				<DrawerToggleIndicator open={open} toggleDrawer={toggleDrawer} />
				<Box sx={{ width: "100%", display: "flex", flexDirection: "column", paddingTop: 2 }}>
					<HeaderText variant="h3" hasBorder={true}>
						{t("order.nonRfid.step4.header")}
					</HeaderText>
					<DrawerSubHeaderText>{t("order.nonRfid.step4.subheader")}</DrawerSubHeaderText>
				</Box>
			</SwipeableArea>
			<DrawerWrapper sx={{ gap: 5, ...(open && { marginTop: "260px" }) }}>
				<PhoneCheckIllustration />
				<Box sx={{ width: "100%", maxWidth: 520 }}>
					<NumberedSteps
						size="large"
						steps={[
							t("order.nonRfid.step4.steps.1"),
							t("order.nonRfid.step4.steps.2"),
							t("order.nonRfid.step4.steps.3"),
						]}
					/>
				</Box>
			</DrawerWrapper>
		</>
	);
};
